export const MAX_TAGS = 20;
export const MAX_TAG_LENGTH = 40;

export function normalizeTags(value) {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  return value.flatMap((tag) => typeof tag === 'string' ? tag.split(/[\s,#＃、]+/u) : [])
    .map((tag) => tag.trim().slice(0, MAX_TAG_LENGTH))
    .filter((tag) => {
      const key = tag.toLocaleLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    }).slice(0, MAX_TAGS);
}

export const getScoreTags = (score) => normalizeTags(score?.tags ?? score?.score?.tags);
